import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { LogOut, Activity, Inbox, Settings, LayoutDashboard } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const role = user?.role;

  const navItems = [
    { to: "/app", label: "CRM", icon: LayoutDashboard, roles: ["commercial", "manager", "admin"] },
    { to: "/app/manager", label: "Reviews", icon: Inbox, roles: ["manager", "admin"] },
    { to: "/app/admin", label: "Settings", icon: Settings, roles: ["admin"] },
  ].filter((i) => i.roles.includes(role));

  return (
    <div className="min-h-screen flex flex-col bg-[#F9FAFB]">
      <header className="border-b border-gray-200 bg-white" data-testid="app-header">
        <div className="max-w-[1400px] mx-auto px-6 h-14 flex items-center justify-between">
          <div className="flex items-center gap-8">
            <Link to="/app" className="flex items-center gap-2" data-testid="brand-link">
              <Activity className="w-4 h-4" strokeWidth={2} />
              <span className="font-heading font-bold text-base tracking-tight">
                iSale<span className="text-gray-400">/V3</span>
              </span>
              <span className="overline text-gray-400 ml-2 hidden md:inline">Passive Mode</span>
            </Link>
            <nav className="flex items-center gap-1">
              {navItems.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  end={item.to === "/app"}
                  data-testid={`nav-${item.label.toLowerCase()}`}
                  className={({ isActive }) =>
                    `px-3 py-1.5 text-sm flex items-center gap-2 rounded-sm transition-colors ${
                      isActive
                        ? "bg-black text-white"
                        : "text-gray-700 hover:bg-gray-100"
                    }`
                  }
                >
                  <item.icon className="w-3.5 h-3.5" strokeWidth={2} />
                  {item.label}
                </NavLink>
              ))}
            </nav>
          </div>
          <div className="flex items-center gap-3">
            <div className="text-right hidden md:block">
              <div className="text-xs font-medium">{user?.name}</div>
              <div className="overline text-gray-400">{user?.role}</div>
            </div>
            <Button
              variant="ghost"
              size="sm"
              onClick={logout}
              data-testid="logout-btn"
              className="rounded-sm"
            >
              <LogOut className="w-3.5 h-3.5" />
            </Button>
          </div>
        </div>
      </header>
      <main className="flex-1">{children}</main>
    </div>
  );
}
